<template>
	<nav v-if="isMobile" class="my-page-mobile-nav">
		<!-- 1단: 큰 묶음 (한 줄에 다 보임) -->
		<div class="group-tabs">
			<button
				v-for="menu of menuList"
				:key="menu.name"
				class="group-tab"
				:class="{ active: menu === activeGroup }"
				@click="onClickGroup(menu)"
			>
				{{ groupLabel(menu.name) }}
			</button>
		</div>
		<!-- 2단: 선택한 묶음의 하위 메뉴 (하나뿐이면 숨김) -->
		<div v-if="activeGroup && activeGroup.list.length > 1" class="sub-tabs">
			<button v-for="item of activeGroup.list" :key="item.name" class="sub-tab" :class="{ active: item.active }" @click="onClickNav(item)">
				{{ item.name }}
			</button>
		</div>
	</nav>
	<nav v-else class="my-page-nav-wrapper">
		<div class="my-page-nav-title">MY PAGE</div>
		<div class="item-wrapper">
			<div v-for="(menu, index) of menuList" :key="menu.name" class="my-page-menu-item">
				<div class="menu-title">{{ menu.name }}</div>
				<div v-for="item of menu.list" :key="item.name" class="menu-nav" :class="{ active: item.active }" @click="onClickNav(item)">
					{{ item.name }}
				</div>
				<hr v-if="index < menuList.length - 1" />
			</div>
		</div>
		<div class="service-center-info">
			<p class="info-name">{{ serviceCenterInfo.name }}</p>
			<p class="info-tel">{{ serviceCenterInfo.tel }}</p>
			<p class="info-time" v-html="serviceCenterInfo.time"></p>
		</div>
	</nav>
</template>

<script>
import PageName from '@/utils/define/PageName'
import { menuList } from '@/utils/define/my-page'
import { isMobile } from '@/utils/device'

// 모바일 1단 탭에 쓰는 짧은 이름
const GROUP_LABEL = {
	'주문 / 배송 관리': '주문·배송',
	'결제 관리': '결제',
	견적: '견적',
	나의정보: '나의 정보',
}

export default {
	name: 'MyPageNav',
	data() {
		return {
			serviceCenterInfo: {
				name: '고객센터',
				tel: '02-799-3170',
				time: `<b">상담시간</b><br />평일 10:00 ~ 17:00<br />Off-time 12:00 ~ 13:00<br />(토/일/공휴일 휴무)`,
			},
			menuList,
			isMobile,
		}
	},
	computed: {
		// 현재 화면이 속한 묶음
		activeGroup() {
			return this.menuList.find(menu => menu.list.some(item => item.active)) || this.menuList[0]
		},
	},
	watch: {
		$route: {
			handler() {
				this.$nextTick(() => this.routeActiveMenu())
			},
			immediate: true,
		},
	},
	methods: {
		groupLabel(name) {
			return GROUP_LABEL[name] || name
		},
		// 묶음을 누르면 그 묶음의 첫 화면으로 이동
		onClickGroup(menu) {
			if (menu === this.activeGroup) return
			this.onClickNav(menu.list[0])
		},
		routeActiveMenu() {
			let activeMenu = null
			this.menuList.forEach(menu => {
				const findMenu = menu.list.find(item => item.component === this.$route.name)
				if (findMenu) activeMenu = findMenu
			})
			if (activeMenu) this.onClickNav(activeMenu)
		},
		onClickNav(menu) {
			this.menuList.forEach(menu => menu.list.forEach(item => (item.active = false)))
			menu.active = true
			this.$emit('active', menu)
		},
	},
}
</script>

<style lang="scss" scoped>
.my-page-nav-wrapper {
	.my-page-nav-title {
		font-size: 1.5rem;
		font-weight: 700;
		padding-bottom: 1rem;
		border-bottom: 1px solid $PRIMARY_BLACK;
	}
	.item-wrapper {
		margin: 1rem 0;
		border-bottom: 1px solid $PRIMARY_BLACK;
		.my-page-menu-item {
			&:last-child {
				.menu-nav:last-child {
					margin-bottom: 1rem;
				}
			}
			.menu-title {
				font-size: 1rem;
				font-weight: 700;
				margin-bottom: 16px;
			}
			.menu-nav {
				font-size: 0.875rem;
				font-weight: 500;
				color: $COLOR_999;
				margin-bottom: 8px;
				cursor: pointer;
				&:hover,
				&.active {
					color: $COLOR_333;
				}
			}
			hr {
				background: $COLOR_CCC;
			}
		}
	}
	.service-center-info {
		margin-bottom: 80px;
		.info-name {
			font-size: 0.75rem;
			font-weight: 700;
		}
		.info-tel {
			font-size: 1.5rem;
			font-weight: 700;
			margin-bottom: 10px;
		}
		.info-time {
			font-size: 0.75rem;
			font-weight: 500;
			color: $COLOR_999;
		}
	}
}

/* ---------- 모바일: 2단 탭 ---------- */
.my-page-mobile-nav {
	.group-tabs {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 6px;
		padding: 4px;
		border-radius: 14px;
		background: #f3f4f6;
		.group-tab {
			height: 40px;
			border-radius: 11px;
			font-size: 0.9rem;
			font-weight: 700;
			color: #6b7280;
			white-space: nowrap;
			&.active {
				background: #161616;
				color: #fff;
			}
		}
	}
	.sub-tabs {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
		margin-top: 10px;
		.sub-tab {
			padding: 7px 14px;
			border: 1px solid #dfe3e8;
			border-radius: 18px;
			background: #fff;
			font-size: 0.85rem;
			color: #4b5563;
			white-space: nowrap;
			&.active {
				border-color: #fabf14;
				background: #fffbea;
				color: #161616;
				font-weight: 800;
			}
		}
	}
}
</style>
